import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { IntlProvider } from "react-intl-redux";

import ErrorBoundary from './components/ErrorBoundary';
import App from './components/App';

const renderSelfRegistration = ({ store }) => {
  ReactDOM.render(
    <React.StrictMode>
        <ErrorBoundary>
          <Provider store={store}>
            <IntlProvider>
              <App />
            </IntlProvider>
          </Provider>
        </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

export default renderSelfRegistration;
